const profileAvatar = document.getElementById('account-change-avatar');
const removeAvatar = document.getElementById('account-change-avatar--remove');
if (profileAvatar) {
	async function readImageFile(file) {
		const reader = new FileReader();

		return new Promise((resolve, reject) => {
			reader.onload = event => resolve(event.target.result);
			reader.onerror = reject;
			reader.readAsDataURL(file);
		});
	}

	profileAvatar.onchange = async event => {
		try {
			const imageDataUrl = await readImageFile(event.target.files[0]);
			document.querySelector('#account-change-avatar--image img').src = imageDataUrl;

			//removeAvatar.classList.remove('d-none')
		} catch (error) {
			console.error("Ошибка при чтении файла", error);
		}
	};

	if (removeAvatar) {
		removeAvatar.onclick = (event) => {
			removeAvatar.classList.add('d-none')
			document.querySelector('#account-change-avatar--image img').src = event.target.dataset.img;
		}
	}
	function resetAvatar() {

	}
}